import { cn } from '@/lib/utils';

// Shared header for phone-preview screens (designer: sc-workflow-preview__header).
// Reads the journey's branding vars (Customization page) with the original
// colours as fallback — so the builder preview is unchanged, while every real
// session step (PAN, Aadhaar, future categories) gets the tenant's branding
// from this ONE component.
//
// Sizes are read from react-new-html WorkflowMobilePreview.css, not estimated:
//
//   .sc-workflow-preview__header   → text-center mb-4        (no top margin)
//   .sc-workflow-preview__title    → text-[24px] font-semibold
//   .sc-workflow-preview__subtitle → text-[15px] mt-1
//
// `compact` is the one documented exception: PanVerificationStandard.tsx — and only
// that screen — overrides the classes inline to a 20px bold title and a 12px
// subtitle, because it is the longest form in the set and needs the room. Every
// other screen uses the base sizes above.
export function PreviewHeader({
  title,
  subtitle,
  compact = false,
}: {
  title: string;
  subtitle: string;
  compact?: boolean;
}) {
  return (
    <div className={cn('text-center', compact ? 'mb-3' : 'mb-4')}>
      <h2
        className={cn(
          'm-0 leading-tight',
          compact ? 'text-[20px] font-bold' : 'text-[24px] font-semibold',
        )}
        style={{ color: 'var(--brand-heading, #111827)' }}
      >
        {title}
      </h2>
      <p
        className={cn('m-0 leading-tight', compact ? 'mt-0.5 text-[12px]' : 'mt-1 text-[15px]')}
        style={{ color: 'var(--brand-body, #6B7280)' }}
      >
        {subtitle}
      </p>
    </div>
  );
}
